// Industry options for the select dropdown
export const INDUSTRY_OPTIONS = [
  { value: '', label: 'Select Industry' },
  { value: '7', label: 'Agriculture' },
  { value: '2', label: 'Construction' },
  { value: '6', label: 'Lawn & Garden' },
  { value: '4', label: 'Forestry' },
  { value: '5', label: 'Golf & Sports' },
  { value: '88', label: 'Tractor Compact - 20-66 engine hp' },
  { value: '87', label: 'Tractor Small - 45-125 engine hp' },
  { value: '89', label: 'Gator Utility Vehicle' },
  { value: '86', label: 'Landscape & Grounds Care' },
  { value: '60', label: 'Compact Construction Equipment' },
  { value: '18', label: 'Industrial Engines – Sales' },
  { value: '21', label: 'Marine Engines - Sales & Service' },
  { value: '27', label: 'Funk Drivetrain - Sales' },
  { value: '28', label: 'Funk Drivetrain - Service' },
  { value: '74', label: 'Engines (Off-Highway), Industrial - Service' },
  { value: '104', label: 'Wirtgen Group' }
];

// Industry filter checkboxes
export const INDUSTRY_FILTERS = [
  { value: 7, label: 'Agriculture' },
  { value: 2, label: 'Construction' },
  { value: 6, label: 'Lawn & Garden' },
  { value: 4, label: 'Forestry' },
  { value: 5, label: 'Golf & Sports' },
  { value: 3, label: 'Engines & Drivetrain' },
  { value: 59, label: 'Tractor Compact' },
  { value: 53, label: 'Tractor Small' },
  { value: 29, label: 'Gator Utility Vehicle' },
  { value: 97, label: 'Landscape & Grounds Care' },
  { value: 60, label: 'Compact Construction Equipment' },
  { value: 104, label: 'Wirtgen Group' }
];

// Boolean select options
export const BOOLEAN_OPTIONS = [
  { value: '', label: 'Not Set' },
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' }
];

// Theme options
export const THEME_OPTIONS = [
  { value: '', label: 'Select Theme' },
  { value: 'enterprise', label: 'Enterprise' },
  { value: 'construction', label: 'Construction' },
];

// Experience options
export const EXPERIENCE_OPTIONS = [
  { value: '', label: 'Select Experience' },
  { value: 'application', label: 'Application' },
  { value: 'brand', label: 'Brand' },
];

// Button color options
export const BUTTON_COLOR_OPTIONS = [
  { value: '', label: 'Select Button Color' },
  { value: 'onLight', label: 'On Light' },
  { value: 'onDark', label: 'On Dark' },
];

// Search type options
export const SEARCH_TYPE_OPTIONS = [
  { value: '', label: 'select from dropdown' },
  { value: 'street', label: 'street' },
  { value: 'city', label: 'city' }
];
